import {isNullOrEmpty} from "./isNullOrEmpty";

export const highlightResult = (htmlString, searchTerms, highlightTag = "b") => {
  if (isNullOrEmpty(htmlString) || isNullOrEmpty(searchTerms)) return htmlString;

  const tag = highlightTag.replace(/[<>]/g, "").trim();
  const openingTag = `<${tag}>`;
  const closingTag = `</${tag}>`;

  const alreadyHighlighted = new RegExp(`${openingTag}.*?${closingTag}`, "i");
  if (alreadyHighlighted.test(htmlString)) return htmlString;

  const terms = searchTerms
    .split(/\s+/)
    .filter(Boolean)
    .map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .sort((a, b) => b.length - a.length);

  if (terms.length === 0) return htmlString;

  const regex = new RegExp(`(${terms.join("|")})`, "gi");

  return htmlString.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, text) => {
    if (tag) return tag;
    return text.replace(regex, (matched) => `${openingTag}${matched}${closingTag}`);
  });
}